<template>
	<main-page :user="user" color="blue">
		<template v-slot:title> TEAM VALUE RUBRIC </template>

		<div class="container">
			<div class="row content">
				<div class="col-6 zone-padding">
					<a class="splash-button-link" href="#/tvr">
						<img class="splash-button" src="@/assets/images/TVR.png" />
					</a>
				</div>
				<div class="col-6 zone-padding d-flex flex-column">
					<h3 class="mt-0 mb-4">Select from the options below:</h3>
					<a class="btn btn-lg btn-no-border btn-si-yellow mb-5" v-if="user.role != 'PARTNER'" href="#/tvr_picker"> Fill Out a TVR </a>
					<a class="btn btn-lg btn-no-border btn-si-green mb-5" href="#/tvr_feedbacks"> TVR Feedback Report </a>
				</div>
			</div>
		</div>

		<template v-slot:footer>
			<div class="col-6 text-right">
				<a class="btn btn-si-secondary" href="#/portfolio">Back</a>
			</div>
		</template>
	</main-page>
</template>

<script>
import MainPage from "@/components/MainPage";

export default {
	name: "TVREntry",

	props: [ "user" ],

	components: { MainPage },

	methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
	margin-top: 3rem;
	margin-bottom: 3rem;
}
.zone-padding {
	padding: 3rem;
}
.splash-button-link > img {
	transition: transform 0.15s ease-in-out;
}
.splash-button-link:hover > img {
	transform: scale(1.05);
}
.splash-button {
	width: 100%;
}
</style>
